import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { PortfolioProvider } from './contexts/PortfolioContext'
import App from './components/App/App'
import './index.css'


ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <PortfolioProvider>
                <App />
            </PortfolioProvider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
)
